import {
  instance,
  file,
} from './index';

const getProducts = async (masterUser) => {
  const res = await instance.get(`/products/all/${masterUser}`);
  return res;
};
const getProduct = async (id) => {
  const res = await instance.get(`/products/${id}`);
  return res;
};
const updateProduct = async (id, data) => {
  const res = await file.put(`/products/${id}`, data);
  return res;
};
const updateProductWoutFile = async (data) => {
  const res = await instance.post('/products', data);
  return res;
};
const updateProductSortId = async (data) => {
  const res = await instance.post('/products/update/sortId', data);
  return res;
};
export {
  getProducts,
  getProduct,
  updateProduct,
  updateProductWoutFile,
  updateProductSortId,
};
